import type { ErrorObject } from '@vuelidate/core'

/**
 * Переводит сообщение ошибки Vuelidate с учётом параметров длины (min/max)
 * для плюрализации ключей вроде base_min_length_chars / base_max_length_chars.
 */
export const useValidationErrorText = () => {
  const { t } = useI18n()

  return (error?: ErrorObject): string => {
    if (!error) {
      return ''
    }

    const key = String(error.$message)
    const params = error.$params as Record<string, unknown>
    const count = typeof params.min === 'number' ? params.min : typeof params.max === 'number' ? params.max : undefined

    if (count === undefined) {
      return t(key)
    }

    return t(key, { n: count }, count)
  }
}
